import { RuleSet } from '../Components/Options';
import { InputType, relativeTimeOptions } from '../types';

export const NumberFormatInput: InputType = [{ value: 12.345, type: 'number' }];

export const RelativeTimeFormatInput: InputType = [
	{ value: 1, type: 'number' },
	{ value: 'day', type: 'options', options: relativeTimeOptions }
];


export const NumberFormatRuleSet: RuleSet = [
	{
		type: 'condition',
		predicate: {
			property: 'compactDisplay',
			values: ['short', 'long']
		},
		implication: {
			property: 'notation',
			allowedValues: ['compact']
		}
	},
	{
		type: 'condition',
		predicate: {
			property: 'notation',
			values: ['engineering', 'scientific', 'standard']
		},
		implication: {
			property: 'compactDisplay',
			allowedValues: []
		}
	}
];
